"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOverflowTooltip = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = require("react");
var _tooltip = require("../components/tooltip");
const useOverflowTooltip = _ref => {
  let {
    isDisabled,
    elementIsOverflowing,
    onBlur,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    tooltipTargetRef,
    placement
  } = _ref;
  const [showOverflowTooltip, setShowOverflowTooltip] = (0, _react.useState)(false);
  const elementToMeasureRefLocal = (0, _react.useRef)(null);
  const onResize = (0, _react.useCallback)(() => {
    if (elementToMeasureRefLocal.current) {
      setShowOverflowTooltip(elementIsOverflowing(elementToMeasureRefLocal.current));
    }
  }, [elementIsOverflowing]);
  const {
    ref: resizeObserverRef
  } = (0, _lodestarUtils.useResizeObserver)(onResize, {
    debounceMs: 1000,
    enabled: !isDisabled
  });
  const {
    tooltipProps,
    targetProps
  } = (0, _tooltip.useTooltip)({
    targetRef: tooltipTargetRef,
    onBlur,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    portalProps: {
      zIndex: _designTokens.layers.tooltip
    },
    placement
  });

  // Since the text is only elided, screen readers can still see it in the DOM.
  // We'll remove this linkage so a SR won't double-read the text AND the tooltip.
  delete targetProps["aria-describedby"];
  const elementToMeasureRef = (0, _lodestarUtils.useForkRef)(resizeObserverRef, elementToMeasureRefLocal);
  return {
    showOverflowTooltip,
    tooltipProps,
    targetProps,
    elementToMeasureRef
  };
};
exports.useOverflowTooltip = useOverflowTooltip;
//# sourceMappingURL=useOverflowTooltip.js.map